import { render } from "./BaseMenuButton.vue?vue&type=template&id=1c3e588e&scoped=true"
import script from "./BaseMenuButton.vue?vue&type=script&lang=js"
export * from "./BaseMenuButton.vue?vue&type=script&lang=js"

import "./BaseMenuButton.vue?vue&type=style&index=0&id=1c3e588e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3e588e"]])

export default __exports__